function BarcodeIcon(props) {
  return (
    <svg id='BarcodeIcon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 44.491 37.512' {...props}>
      <path
        id='Tracciato_55'
        data-name='Tracciato 55'
        d='M70.491,43.309v8.724a1.309,1.309,0,0,1-2.617,0V44.617H60.458a1.309,1.309,0,0,1,0-2.617h8.724A1.309,1.309,0,0,1,70.491,43.309ZM36.032,76.895H28.617V69.479a1.309,1.309,0,0,0-2.617,0V78.2a1.309,1.309,0,0,0,1.309,1.309h8.724a1.309,1.309,0,0,0,0-2.617Zm33.15-8.724a1.309,1.309,0,0,0-1.309,1.309v7.415H60.458a1.309,1.309,0,0,0,0,2.617h8.724A1.309,1.309,0,0,0,70.491,78.2V69.479A1.309,1.309,0,0,0,69.182,68.171ZM27.309,53.341a1.309,1.309,0,0,0,1.309-1.309V44.617h7.415a1.309,1.309,0,1,0,0-2.617H27.309A1.309,1.309,0,0,0,26,43.309v8.724A1.309,1.309,0,0,0,27.309,53.341Zm10.468-2.617a1.309,1.309,0,0,0-1.309,1.309V69.479a1.309,1.309,0,1,0,2.617,0V52.032A1.309,1.309,0,0,0,37.777,50.724ZM60.022,69.479V52.032a1.309,1.309,0,1,0-2.617,0V69.479a1.309,1.309,0,1,0,2.617,0ZM51.735,50.724a1.309,1.309,0,0,0-1.309,1.309V69.479a1.309,1.309,0,0,0,2.617,0V52.032A1.309,1.309,0,0,0,51.735,50.724Zm-6.979,0a1.309,1.309,0,0,0-1.309,1.309V69.479a1.309,1.309,0,1,0,2.617,0V52.032A1.309,1.309,0,0,0,44.756,50.724Z'
        transform='translate(-26 -42)'
        fill='currentColor'
      />
    </svg>
  )
}

export default BarcodeIcon
